import { EcoFeeSettings } from "./types";

export const transformEcoFeeSettings = (res: any): EcoFeeSettings => ({
  perKgRate: res.perKgRate ?? 0,
  driverMassDeductionKg: res.driverMassDeductionKg ?? 0,
  fuelMassDeductionKg: res.fuelMassDeductionKg ?? 0,
  tireFeeM1: res.tireFeeM1 ?? 0,
  tireFeeN1: res.tireFeeN1 ?? 0,
});
